import styled from "styled-components";

export const MainContainer = styled.main`
    margin: 0 7px 0 7px;
    background-color: #fff;
    box-shadow: 0px 5px 9px -4px rgb(0 0 0 / 22%);
`